import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/BecomeSeller.css";
import { isEmpty } from "../functions/isEmpty";
import { useLocation, useNavigate } from "react-router";
import VideoRecorder from "../components/VideoRecorder";

export default function BecomeSeller({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  becomeSellerActive,
  setBecomeSellerActive,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;

  const becomeACreator = () => {
    setBecomeSellerActive(true);
    if (isEmpty(authToken)) {
      navigate("/login?becomeSeller=true");
    } else {
      navigate("/sellerprofile");
    }
  };

  return (
    <div className="becomeseller">
      {isMobile ? (
        <div className="becomeseller_topnav">
          <div
            className="becomeseller_topnav_left"
            onClick={() =>
              isEmpty(authToken) ? navigate("/") : navigate("/")
            }>
            <ArrowBack /> Geld verdienen
          </div>
        </div>
      ) : (
        <div className="becomeseller_topnav">
          <div
            className="becomeseller_topnav_left_title"
            onClick={() =>
              isEmpty(authToken) ? navigate("/") : navigate("/")
            }>
            <ArrowBackDesktop />
            Geld verdienen
          </div>
        </div>
      )}
      <div className="becomeseller_body">
        <div className="becomeseller_body_headline">
          Verdiene Geld mit bezahlten Storyposts
        </div>
        <div className="becomeseller_body_subtext">
          Erstelle Werbe-Storyposts auf doodli und Unternehmen bezahlen dich sie
          auf deinem Kanal zu teilen
        </div>
        <div className="becomeseller_body_imgbox">
          <img src="" className="becomeseller_body_imgbox_img" />
          {/* ein bild wo man selfie macht links und geld verdient rechts*/}
        </div>
        {!isEmpty(authToken) ? (
          <div
            className="becomeseller_body_cta"
            onClick={() => navigate("/login?becomeSeller=true")}>
            Als Creator loslegen
          </div>
        ) : (
          <div
            className="becomeseller_body_cta"
            onClick={() => becomeACreator()}>
            Als Creator loslegen
          </div>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
